import React, { useState, useEffect, useCallback } from 'react'
import Style from 'ol/style/Style'
import { serieAmostraColorsForMap } from '../../data/UtilCoresLimiares';
import { unByKey } from 'ol/Observable';
import mining from "../../assets/mining.svg";
import mining_disabled from "../../assets/mining_disabled.svg";

const EMPTY_STYLE = new Style();
const ORIGINAL_FEATURE_STYLE_PROPERTY = 'originalStyle';

var changeRepresentacao = false
export default (props) => {

    const [legends, setLegends] = useState(null)
    const [reload, forceUpdate] = useState(true)
    const [geologiaLegends, setGeologiaLegends] = useState([])
    const [legendaAnalise, setLegendaAnalise] = useState()
    const [representacaoAtual, setRepresentacaoAtual] = useState()
    const size = props.size

    const carregarCamada = useCallback((camada) => {
        const features = camada.layer.olLayer.getSource().getFeatures()
        switch (camada.layer.name) {
            case 'Geologia':
                createLegendGeologia(features)
                break;
            case 'Amostragem':
                camada.loading = false
                break;
            default:
                break;
        }
    }, [])

    const listenerLayer = useCallback((camada) => {
        const features = camada.layer.olLayer.getSource().getFeatures()
        if (features.length > 0) {
            carregarCamada(camada)
        } else {
            const listenerKey = camada.layer.olLayer.getSource().on('change', event => {
                carregarCamada(camada)
                unByKey(listenerKey);
            })
        }
    }, [carregarCamada])

    const listenersLoadChange = useCallback((layers) => {
        setGeologiaLegends([])
        layers.forEach(layer => {
            listenerLayer(layer)
        });
    }, [listenerLayer])

    useEffect(() => {
        if (!props.layersToShow.length === 0) return

        listenersLoadChange(props.layersToShow)

        const legend = props.layersToShow
            .filter(layer => !layer.ocultarCamada)
            .map(layer => layer.layer.legend)

        legend.map(leg => {
            return leg && leg.items.map(item => {
                return item.selected = item.hasOwnProperty('selected') ? item.selected : true
            })
        })
        setLegends(legend)
    }, [listenersLoadChange, props.layersToShow])

    const resizeWindow = useCallback(() => {
        if (!document.getElementById("divLegenda")) return

        const divs = Object.values(document.getElementById("divLegenda").getElementsByTagName("div"))
        let maxWidth = Math.max(...divs.map(div => div.clientWidth))
        let maxHeigth = Math.max(...divs.map(div => div.clientHeight))

        if (maxWidth < 220 || maxHeigth < 200 || divs.length === 0) {
            maxHeigth = 200 - 65
            maxWidth = 220 - 35
        }

        const oQuickReplyswap = () => {
            return size({
                height: maxHeigth + 65,
                width: maxWidth + 35,
            })
        }
        document.getElementById("divLegenda").onload = oQuickReplyswap()
    }, [size])

    useEffect(() => {
        resizeWindow()
    }, [props.legendaAnalise, legends, geologiaLegends, resizeWindow])

    const toggleActiveLayer = useCallback((layerLegendItem) => {
        layerLegendItem.selected = !layerLegendItem.selected

        const associatedFeatures = layerLegendItem.findAssociatedFeatures();

        if (layerLegendItem.selected) {
            associatedFeatures && associatedFeatures.forEach(restoreFeatureStyle);
        } else {
            associatedFeatures && associatedFeatures.forEach(clearAndStoreFeatureStyle);
            // props.selectedFeaturesChanged(associatedFeatures)
        }

        function clearAndStoreFeatureStyle(feature) {
            const style = feature.getStyle();
            if (style) {
                feature.set(ORIGINAL_FEATURE_STYLE_PROPERTY, style, true);
            }
            feature.setStyle(EMPTY_STYLE);
        }

        forceUpdate(!reload)
    }, [reload])

    useEffect(() => {
        if (!props.parametroSerie) return
        //if (!props.legends || props.legends.length === 0) return

        if (legends) {
            const amostras = legends.filter(l => l && l.title === 'Amostragem')[0]
            if (amostras && amostras.length > 0 && amostras.items && amostras.items.length > 0) {
                const items = amostras.items[0]
                if (!items.selected) toggleActiveLayer(items)
            }
        }

        if (!representacaoAtual || representacaoAtual === props.parametroSerie.representacao) {
            changeRepresentacao = false
        } else
            changeRepresentacao = true

        setRepresentacaoAtual(props.parametroSerie.representacao)
    }, [legends, props.parametroSerie, representacaoAtual, toggleActiveLayer])

    const atualizarLegendaQuandoRepresentacaoForAlterada = useCallback(() => {
        if (legendaAnalise && props.legendaAnalise) {
            legendaAnalise.forEach(la => {
                const iconPropslegendAnalise = props.legendaAnalise.filter(pla => pla.title === la.title)[0]
                if (iconPropslegendAnalise)
                    la.icon.findAssociatedFeatures = props.legendaAnalise.filter(pla => pla.title === la.title)[0].icon.findAssociatedFeatures
            })
        }

        if (legendaAnalise) {
            legendaAnalise.forEach(la => toggleActiveLayer(la.icon))
            legendaAnalise.forEach(la => toggleActiveLayer(la.icon))
        }
    }, [legendaAnalise, props.legendaAnalise, toggleActiveLayer])

    useEffect(() => {
        if (!props.parametroSerie) return
        if (!legendaAnalise && props.legendaAnalise) setLegendaAnalise(props.legendaAnalise)

        if (changeRepresentacao)
            atualizarLegendaQuandoRepresentacaoForAlterada()
        else {
            setLegendaAnalise(props.legendaAnalise)
        }
    }, [atualizarLegendaQuandoRepresentacaoForAlterada, legendaAnalise, props.legendaAnalise, props.parametroSerie])

    useEffect(() => {
        if (!props.restoreStyleFeatures) return

        props.restoreStyleFeatures.forEach(features => {
            features && features.forEach(restoreFeatureStyle);
        })
    }, [props.restoreStyleFeatures])

    const createLegendGeologia = (features) => {
        const grupos = [...new Set(features.map(feature => feature.get('dominio')))].sort()

        const getItems = (grupo) => {
            const featuresPorGrupo = features.filter(feature => feature.get('dominio') === grupo)
            const items =
                [...new Set(featuresPorGrupo.map(feature => feature.get('NOME_UNIDA')))]
                    .map(item => ({
                        description: item,
                        color: featuresPorGrupo.filter(feature => feature.get('NOME_UNIDA') === item)[0].get('cor'),
                        features: featuresPorGrupo.filter(feature => feature.get('NOME_UNIDA') === item)
                    }))

            return items.map(item => ({
                description: item.description,
                qtd: item.features.length,
                icon: {
                    icon: 'rectangle',
                    color: item.color,
                    selected: true,
                    findAssociatedFeatures: () => item.features
                }
            })).sort((a, b) => a.description.localeCompare(b.description, 'pt-BR'))
        }

        const legends = grupos.map(grupo => ({
            title: grupo,
            items: getItems(grupo)
        }))

        setGeologiaLegends(legends)
    }

    const createLayerLegendElements = (legends) => {
        if (!legends || !legends.title) return
        return (
            <div key={"legend_" + legends.id} className="layerLegend">
                {legends.title &&
                    <div className="layerLegendTitle">{legends.title}</div>
                }

                {legends.items.map(layerLegendItem => {
                    return (createLayerLegendItemsElements(layerLegendItem))
                })}

            </div>
        )
    }

    const createLayerLegendItemsElements = (layerLegendItem) => {
        return (
            <div key={"legendItens_" + layerLegendItem.id} className={"legendItem" + (layerLegendItem.legend.title === " " ? "Recuado" : "")}>
                {layerLegendItem.icon === 'minas' ?
                    createSVGIcon(layerLegendItem)
                    :
                    <div className="legendItemSymbol">
                        <svg className="svgLegendItemSymbol">
                            {createSVGIcon(layerLegendItem)}
                        </svg>
                    </div>
                }
                <div className="legendItemDescription">
                    {/* {layerLegendItem.description} ({layerLegendItem.findAssociatedFeatures().length}) */}
                    <label style={{ color: layerLegendItem.selected ? "#000" : "rgba(0,0,0,0.4)" }}>{layerLegendItem.description}</label>
                    <label style={{ marginLeft: 3, color: layerLegendItem.selected ? "gray" : "rgba(0,0,0,0.4)" }}>
                        ({layerLegendItem.findAssociatedFeatures().length})
                    </label>
                </div>
            </div>
        )
    }

    const createSVGIcon = (layerLegendItem) => {
        if (!layerLegendItem) return

        const { selectedFeaturesChanged } = props;
        const show = layerLegendItem.hasOwnProperty('selected') ? layerLegendItem.selected : true

        const iconProperties = {
            fill: getColor(layerLegendItem),
            fillOpacity: !layerLegendItem.selected ? 0 : 1,
            stroke: !layerLegendItem.selected ? "rgba(150,150,150)" : "#d3c9c1",
            strokeWidth: layerLegendItem.icon === "rectangle" ? 2 : 1,
            color: layerLegendItem.color,
            className: 'svgLegendItemIcon',
            onMouseEnter: () => show && representacaoAtual !== '-1' && selectedFeaturesChanged(layerLegendItem.findAssociatedFeatures()),
            onMouseLeave: () => show && selectedFeaturesChanged(),
            onClick: () => representacaoAtual !== '-1' && toggleActiveLayer(layerLegendItem)
        };

        switch (layerLegendItem.icon) {
            case 'circle': return createSVGCircle(iconProperties, !layerLegendItem.selected);
            case 'rectangle': return createSVGRectangle(iconProperties, !layerLegendItem.selected);
            case 'polygon': return createSVGPolygon(iconProperties, !layerLegendItem.selected);
            case 'line': return createSVGLine(iconProperties, !layerLegendItem.selected);
            case 'minas': return createSVGMinas(iconProperties, !layerLegendItem.selected);
            default: throw new Error(`Invalid icon: ${layerLegendItem.icon}`);
        }

    }

    const getColor = (layerLegendItem) => {
        // if (!layerLegendItem.selected) return 'black'
        if (layerLegendItem.color) return layerLegendItem.color
        return serieAmostraColorsForMap.get(props.parametroSerie.serie.serie)
    }

    function restoreFeatureStyle(feature) {
        if (feature.getStyle() !== EMPTY_STYLE) {
            return;
        }

        feature.setStyle(feature.get(ORIGINAL_FEATURE_STYLE_PROPERTY));
        feature.unset(ORIGINAL_FEATURE_STYLE_PROPERTY, true);
    }

    const createSVGCircle = (iconProperties, disabled) => {
        return (
            <>
                <circle cx="9" cy="9" r="7" {...iconProperties} />
                {disabled && (
                    <line x1="17" y1="0" x2="0" y2="17" style={{ stroke: iconProperties.stroke, strokeWidth: 1 }} />
                )}
            </>
        )
    }

    const createSVGRectangle = (iconProperties, disabled) => {
        return (
            <>
                <rect x="0" y="0" width="17" height="17" {...iconProperties} />
                {disabled && (
                    <line x1="17" y1="0" x2="0" y2="17" style={{ stroke: iconProperties.stroke, strokeWidth: 1 }} />
                )}
            </>
        )
    }

    const createSVGPolygon = (iconProperties, disabled) => {
        const newProperties = {
            ...iconProperties,
            'fill': '#fff',
            'stroke': !disabled ? iconProperties.color : 'gray',
            'strokeWidth': 25
        }
        return (
            <>
                <svg viewBox='180 100 400 400' {...newProperties} >
                    <path d='M 400 120 C 325 90 375 90 280 120 Q 160 160 200 280 Q 260 300 320 400 L 440 380 Q 500 360 500 300 L 540 200 C 480 60 480 200 400 120 '>
                    </path>
                    {disabled && (
                        <line x1="550" y1="100" x2="200" y2="400" style={{ stroke: iconProperties.stroke, strokeWidth: 15 }} />
                    )}
                </svg>
            </>
        )
    }

    const createSVGLine = (iconProperties, disabled) => {
        const newProperties = {
            ...iconProperties,
            'fill': '#fff',
            'stroke': !disabled ? iconProperties.color : 'gray',
            'strokeWidth': 25
        }
        return (
            <>
                <svg viewBox='180 100 400 400' {...newProperties} >
                    <path d='M 200 100 C 450 450 350 100 600 450 '>
                    </path>
                    {disabled && (
                        <line x1="550" y1="100" x2="200" y2="400" style={{ stroke: iconProperties.stroke, strokeWidth: 15 }} />
                    )}
                </svg>
            </>
        )
    }

    const createSVGMinas = (iconProperties, disabled) => {
        return (
            <>
                <img src={disabled ? mining_disabled : mining} {...iconProperties} onMouseEnter={() => { }} onMouseLeave={() => { }} height="15px" width="17px" color='red' alt="" />
            </>
        )
    }

    return (
        <div id="divLegenda">
            {legends && legends.map(legends => {
                return (createLayerLegendElements(legends))
            })}

            {props.parametroSerie && legendaAnalise &&
                <div className="layerLegend">

                    {legendaAnalise.length > 0 &&
                        <div className="layerLegendTitle">{props.parametroSerie.parametro.nome} ({props.parametroSerie.serie.nomeUnidade})</div>
                    }

                    {legendaAnalise.map((legends, index) => {
                        return <div key={"legend_" + index} className="legendItem">
                            <div className="legendItemSymbol">
                                <svg className="svgLegendItemSymbol">
                                    {createSVGIcon(legends.icon)}
                                </svg>
                            </div>
                            <div className="legendItemDescription">
                                <label style={{ color: legends.icon.selected ? "#000" : "rgba(0,0,0,0.4)" }}>{legends.title}</label>
                                <label style={{ marginLeft: 3, color: legends.icon.selected ? "gray" : "rgba(0,0,0,0.4)" }}>
                                    ({legends.qtd})
                                </label>
                            </div>
                        </div>
                    })}

                </div>
            }

            {geologiaLegends.length > 0 &&
                <div className="layerLegend" id="divLegenda2">

                    {geologiaLegends.length > 0 &&
                        <div className="layerLegendTitle">Geologia</div>
                    }

                    {geologiaLegends.map((legends, index) => {
                        return <div key={"legendSubItem_" + index} className="legendItem">
                            <div className="layerLegendSubTitle">
                                {legends.title}

                                {legends.items.map((legend, index) => {
                                    return <div key={"legendItem_" + index} className="legendItem">
                                        <div className="legendItemSymbol">
                                            <svg className="svgLegendItemSymbol">
                                                {createSVGIcon(legend.icon)}
                                            </svg>
                                        </div>
                                        <div className="legendItemDescription" id='teste'>
                                            <label style={{ color: legend.icon.selected ? "#000" : "rgba(0,0,0,0.4)" }}>{legend.description}</label>
                                            <label style={{ marginLeft: 3, color: legend.icon.selected ? "gray" : "rgba(0,0,0,0.4)" }}>
                                                ({legend.qtd})
                                            </label>
                                        </div>
                                    </div>
                                })}
                            </div>

                        </div>
                    })}

                </div>
            }
        </div>
    )

}
